import * as yup from 'yup';
import { NotificationCard } from '@web/components';
import { requiredImageFromCMSSchema } from '../schemas';

export const component = NotificationCard;

export const schema = yup
  .object({
    icon: requiredImageFromCMSSchema,
    subject: yup.string().required(),
    subjectTypography: yup.string(),
    subjectFontColor: yup.string(),
    message: yup.string(),
    messageTypography: yup.string(),
    messageFontColor: yup.string(),
  })
  .transform(value => ({
    icon: value.icon,
    subject: value.subject,
    subjectTypography: value.subject_typography || undefined,
    subjectFontColor: value.subject_font_color || undefined,
    message: value.message || undefined,
    messageTypography: value.message_typography || undefined,
    messageFontColor: value.message_font_color || undefined,
  }));
